import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DefaultResponseWithData } from "../models/system";
import { ICollectionOption } from "../models/CollectionOption";
import useApiHelper from "../hooks/useApiHelper";

export function useCollectionOptions() {
  const { get, post } = useApiHelper();
  const queryClient = useQueryClient();

  const collectionOptions = useQuery({
    queryKey: ["collection-options"],
    queryFn: () => get<DefaultResponseWithData<ICollectionOption[]>>(`/collectionoption`),
  });

  const create = useMutation(
    (collectionOption: ICollectionOption) => post("/collectionoption", collectionOption),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["collection-options"]);
      },
    }
  );

  return {
    collectionOptions,
    create,
  };
}
